
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnLaborGrid extends Serenity.EntityGrid<JobWorkReturnLaborRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturnLabor'; } 
        protected getIdProperty() { return JobWorkReturnLaborRow.idProperty; }
        protected getInsertPermission() { return JobWorkReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReturnLaborRow.localTextPrefix; }
        protected getService() { return JobWorkReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}